import { InjectionToken } from '@angular/core';
import { MapCommand } from '../map-command.class';

/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
export const DESELECT_COMMAND = new InjectionToken<MapCommand>('DESELECT_COMMAND');
